import { createFileRoute } from '@tanstack/react-router';
import ProvidedJobPostsNewTemplate from '@/features/agent/provided_job_posts/templates/ProvidedJobPostsNewTemplate';

export const Route = createFileRoute('/agent/provided_job_posts/new/manual/')({
  component: ProvidedJobPostsNew,
});

function ProvidedJobPostsNew() {
  return <ProvidedJobPostsNewTemplate />;
}
